import type { Environment } from '../environments/environment.type';

/** Subset of `TranslocoConfig` this factory is responsible for deriving. */
export interface TranslocoLangConfig {
  defaultLang: string;
  fallbackLang: string;
  availableLangs: string[];
}

/**
 * Pure factory deriving the Transloco runtime lang config from
 * `environment.lang` (design D3 of `centralize-langs`).
 *
 * - `defaultLang` / `fallbackLang` come from `lang.fallback` — the
 *   frontend's default language (startup, missing keys, pre-auth contexts
 *   such as login).
 * - `availableLangs` comes from `lang.langs` — the universe of languages
 *   this installation serves.
 * - `lang.base` (the principal DATA language) NEVER intervenes here: it is
 *   a separate concept and this factory doesn't even read it.
 */
export function buildTranslocoLangConfig(lang: Environment['lang']): TranslocoLangConfig {
  return {
    defaultLang: lang.fallback,
    fallbackLang: lang.fallback,
    availableLangs: [...lang.langs],
  };
}
